export const inputCls = (hasError: boolean) =>
  `w-full px-4 py-2.5 rounded-xl border text-sm text-slate-700 bg-slate-50/60
   placeholder-slate-300 focus:outline-none focus:ring-2 focus:bg-white
   transition-all duration-150 disabled:opacity-50 disabled:cursor-not-allowed
   ${
     hasError
       ? "border-rose-300 focus:border-rose-400 focus:ring-rose-100"
       : "border-slate-200 hover:border-slate-300 focus:border-[#0F52BA] focus:ring-blue-100"
   }`;